export default __webpack_public_path__ + "static/media/IWA.aed4d2a0.jpg";